import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavigationBar from "./components/Navbar";
import Home from "./pages/Home";
import IngredientsPage from "./pages/IngredientsPage";
import ShoppingList from "./components/ShoppingList/ShoppingList";
import RecipesPage from "./pages/RecipesPage";
import NotificationsPage from "./pages/NotificationsPage";
import { Container } from "react-bootstrap";
import Footer from "./components/Footer";
import './App.css';

function App() {
    const [ingredients, setIngredients] = useState(() => {
        const storedIngredients = localStorage.getItem("ingredients");
        return storedIngredients ? JSON.parse(storedIngredients) : [];
    });

    useEffect(() => {
        localStorage.setItem("ingredients", JSON.stringify(ingredients));
    }, [ingredients]);

    const addIngredient = (ingredient) => {
        setIngredients([...ingredients, ingredient]);
    };
    return (
        <Router basename="/">
            <NavigationBar />
            <Container className="mt-4 pb-5">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/ingredients" element={<IngredientsPage />} />
                    <Route path="/shopping-list" element={<ShoppingList addIngredient={addIngredient} />} />
                    <Route path="/recipes" element={<RecipesPage />} />
                    <Route path="/notifications" element={<NotificationsPage />} />
                </Routes>
            </Container>
            <Footer />
        </Router>
    );
}

export default App;
